import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import GridPaper from "../../util/GridPaper";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { findAll } from "../NotaBimestreTipo/api-nota-bimestre-tipo";
import Box from "../UI/Box";
import AlunoTextFieldSelect from "../Aluno/UI/AlunoTextFieldSelect";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    // marginTop: theme.spacing(1),
  },
  title: {
    paddingTop: "20px;",
  },
  submit: {
    // margin: theme.spacing(3, 0, 2),
  },
  loading: {
    margin: "20px",
  },
}));

export default function RelatorioAlunoNotaBimestreTipoForm() {
  const classes = useStyles();
  const [aluno, setAluno] = useState(null);
  const [listNBTipo, setListNBTipo] = useState([]);
  const [nbTipo, setNbTipo] = useState(null);

  useEffect(() => {
    findAll().then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setListNBTipo(data);
        }
      }
    });
  }, []);

  const handleNbTipoChange = (event) => {
    setNbTipo(listNBTipo.find((t) => t.codigo === event.target.value));
  };

  return (
    <Container>
      <Typography className={classes.title} variant="body1">
        Por Aluno e Nota Bimestre Tipo
      </Typography>
      <GridPaper container justifyContent="center" spacing={3}>
        <Grid size={12}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl required fullWidth>
              <AlunoTextFieldSelect aluno={aluno} setAluno={setAluno} />
            </FormControl>
          </Box>
        </Grid>
        <Grid size={12}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl required fullWidth>
              <InputLabel id="turma-label">Nota Bimestre Tipo</InputLabel>
              <Select
                labelId="turma-label"
                id="turma-select"
                value={nbTipo ? nbTipo.codigo : ""}
                onChange={handleNbTipoChange}
              >
                {listNBTipo.map((t) => (
                  <MenuItem key={t.codigo} value={t.codigo}>
                    {t.descricao}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>

        <Grid>
          <Button
            component={Link}
            to={{
              pathname: "/relatorio-web-aluno-nota-bimestre-tipo",
            }}
            state={{
              codAluno: aluno ? aluno.codigo : null,
              codNotaBimestreTipo: nbTipo ? nbTipo.codigo : null,
            }}
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Aluno - Nota Bimestre Tipo
          </Button>
        </Grid>
      </GridPaper>
    </Container>
  );
}
